module.exports = require("././angular-moment.js");


/*****************
 ** WEBPACK FOOTER
 ** angular-moment (bower component)
 ** module id = 370
 ** module chunks = 1
 **/